import { createSelector } from 'reselect'
import featureScopesSelector from './featureScopesSelector'

const isClearOnInitEnabledSelector = createSelector(
    featureScopesSelector,
    (featureScopes): boolean => featureScopes.includes('clearOnInit'),
)

export default isClearOnInitEnabledSelector
